// extracted by mini-css-extract-plugin
export default {"productDiscount":"_1MVUcS8"};